<template>
  <div class="main-pcAsignacionDatosOrigen">
    <f7-card
      outline
      class="content-data-card-outline no-margin"
    >
      <f7-card-content
        class="content-card-outline__content"
      >
        <div
          class="content-card-outline__content--data"
        >
          <div
            class="content-title"
          >
            <div class="content-title__div ">
              <span class="content-title__div-title"> {{ titulo }}</span>
            </div>
            <div class="content-title__div">
              <span class="content-title__div-subtitle"> {{ subtitulo }}</span>
            </div>
            <div class="content-title__div">
              <span class="content-title__div-text"> {{ text }}</span>
            </div>
          </div>
          <div class="content-after">
            <span class="content-after__span">
              {{ `${totalEnvasesStepper} ${$t('common.of')} ${totalEnvases !== 0 ? totalEnvases : articulosAsignados}` }} <img src="@/static/icons/ic_box_blue.svg">
            </span>
          </div>
        </div>
      </f7-card-content>
    </f7-card>
    <f7-list
      v-if="datosOrigenPale !== null && datosOrigenPale.length > 0"
      media-list
      class="content-data-list"
    >
      <f7-list-item
        v-for="(pale, i) in datosOrigenPale"
        :key="i"
      >
        <div
          v-if="pale.TipoArticuloFamiliaConfeccion !== 2"
          class="content-data-list__data"
        >
          <div
            class="content-data-list__data--title"
          >
            <div><span class="title"> {{ pale.ArticuloNumeroSerie ? pale.ArticuloNumeroSerie.NumeroSerie : '' }} </span></div>
            <div>
              <span
                class="subtitle"
              >
                {{
                  `${$t('common.originBatch')}: ${pale.ArticuloNumeroSerie.DatosOrigen.length > 0
                    ? pale.ArticuloNumeroSerie.DatosOrigen.map(datosOrigen => `${datosOrigen.Partida.Serie} / ${datosOrigen.Partida.Numero}`).join(',')
                    : ''}`
                }}
              </span>
            </div>
          </div>
          <div class="content-data-list__data--stepper">
            <small class="display-flex justify-content-center">
              {{ $t('common.packages') }}
            </small>
            <f7-stepper
              :id="i"
              fill
              :value="pale.ArticuloNumeroSerie.DatosOrigen[0].Partida.Cantidad"
              :min="0"
              :max="100000"
              @input="UpdateDatosOrigenStepperValue(pale.Id, pale.ArticuloNumeroSerie.DatosOrigen, $event.target.value)"
            />
          </div>
          <!-- <div class="content-data-list__data--kilos">
                <small class="display-flex justify-content-center">
                  {{ $t('common.kilos') }}
                </small>
                <div>
                  <span class="content-kilos-number"> 0 </span>
                </div>
              </div> -->
          <div class="content-data-list__data--delete">
            <img
              alt="iconDelete"
              src="@/static/icons/ic_delete.svg"
              width="40"
              @click="EliminarPartida(pale.ArticuloNumeroSerie.NumeroSerie, 0)"
            >
          </div>
        </div>
        <template v-else-if="pale.ArticuloNumeroSerie.DatosOrigen.length > 0">
          <div
            v-for="(datosOrigen, k) in pale.ArticuloNumeroSerie.DatosOrigen"
            :key="k"
            class="content-data-list__data"
          >
            <div class="content-data-list__data--title">
              <div><span class="title"> {{ pale.ArticuloNumeroSerie ? pale.ArticuloNumeroSerie.NumeroSerie : '' }} </span></div>
              <div>
                <span class="subtitle">
                  {{ `${$t('common.originBatch')}: ${datosOrigen.Partida.Serie} / ${datosOrigen.Partida.Numero}` }}
                </span>
              </div>
            </div>
            <div class="content-data-list__data--stepper">
              <small class="display-flex justify-content-center">
                {{ $t('common.packages') }}
              </small>
              <f7-stepper
                :id="`${i}-${k}`"
                fill
                :value="datosOrigen.Partida.Cantidad"
                :min="0"
                :max="10000"
                @input="UpdateDatosOrigenStepperValue(pale.Id, [datosOrigen], $event.target.value);"
              />
            </div>
            <!-- <div class="content-data-list__data--kilos">
                  <small class="display-flex justify-content-center">
                    {{ $t('common.kilos') }}
                  </small>
                  <div>
                    <span class="content-kilos-number"> {{ datosOrigen.Partida.Cantidad }} </span>
                  </div>
                </div> -->
            <div class="content-data-list__data--delete">
              <img
                alt="iconDelete"
                src="@/static/icons/ic_delete.svg"
                width="40"
                @click="EliminarPartida(pale.ArticuloNumeroSerie.NumeroSerie, datosOrigen.Partida)"
              >
            </div>
          </div>
        </template>
      </f7-list-item>
    </f7-list>

    <f7-popup
      class="content-last-dump-popup"
      :opened="popupPalesVolcados"
      @popup:closed="popupPalesVolcados = false"
    >
      <TheNavbar
        :nav-title="$t('production.latestPalletsDump.title')"
        :back-btn-enable="false"
        :style="appTheme"
      />
      <PCUltimosPalesVolcados
        ref="PCUltimosPalesVolcados"
        @valores-stepper="(value) => valoresVolcadosStepper = value"
      />
      <div class="content-last-dump-popup__buttons">
        <div class="content-buttons-origin-data-asignation">
          <f7-button
            class="button-reject"
            @click="CancelButtonClickLastDump"
          >
            {{ $t('common.cancel') }}
          </f7-button>
          <f7-button
            class="button-confirm"
            @click="ConfirmButtonClickLastDump"
          >
            {{ $t('common.confirm') }}
          </f7-button>
        </div>
      </div>
    </f7-popup>

    <UCCodeScanner
      ref="componentUCcodeScanner"
      :allow-manual-code-entry="true"
      :fab-button-show="false"
      orientation-scan="landscape"
      :auto-open-camera="false"
    >
      <template #inputCodeScanner>
        <div>
          <PCCodeScannerTiposLecturas
            :autofocus-on-input="true"
            @numero-serie="NumeroSerieReadingEvent"
          />
        </div>
      </template>
    </UCCodeScanner>
  </div>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import {
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import { callExecuteSPERP } from '@/js/services/APIErp';
import ConexionTA from '@/js/services/traceability/APITraceability';
import PCUltimosPalesVolcados from '@/components/production/traceability/PCUltimosPalesVolcados.vue';
import TheNavbar from '@/components/TheNavbar.vue';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import PCCodeScannerTiposLecturas from '@/components/production/commercialization/picking/PCCodeScannerTiposLecturas.vue';

export default {
  name: 'PCAsignacionDatosOrigen',
  components: {
    PCUltimosPalesVolcados,
    TheNavbar,
    UCCodeScanner,
    PCCodeScannerTiposLecturas,
  },
  props: {
    titulo: {
      type: String,
      default: '',
    },
    subtitulo: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    articulosAsignados: {
      type: Number,
      default: 0,
    },
    totalEnvases: {
      type: Number,
      default: 0,
    },
    productoPaleEnCurso: {
      type: Object,
      default: null,
    },
  },

  emits: [
    'add-button',
    'valores-stepper',
  ],

  data() {
    return {
      totalEnvasesStepper: 0,
      valoresStepper: {},
      popupPalesVolcados: false, // Controla la apertura de popup de pales volcados.
      valoresVolcadosStepper: {},
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'paleEnCurso',
      'partidasVisualizadas',
      'puntoDePaletizadoSeleccionado',
    ]),

    ...mapWritableState(useTraceabilityStore, [
      'datosOrigenPale',
      'ultimosPalesVolcados',
    ]),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-plum-shadow)',
        '--f7-navbar-text-color': '#fff',
      };
    },
  },
  watch: {
    popupAsignacionDatosOrigen(val) {
      return val;
    },
  },

  created() {
    if (this.paleEnCurso) {
      this.Conections_GetOriginPallet();
    }
  },

  methods: {
    EventAddBtn() {
      Log(this, this.EventAddBtn.name);
      this.$emit('add-button');
    },
    UpdateDatosOrigenStepperValue(idPale, datosOrigen, value) {
      Log(this, this.UpdateDatosOrigenStepperValue.name);
      datosOrigen.forEach((d) => {
        this.valoresStepper[`${idPale}-${d.Partida.Id}`] = Number.parseInt(value, 10);
        d.Partida.Cantidad = Number.parseInt(value, 10);
      });

      this.$emit('valores-stepper', this.valoresStepper);
      this.CambiarTotalEnvases();
    },

    CambiarTotalEnvases() {
      Log(this, this.CambiarTotalEnvases.name);

      this.totalEnvasesStepper = 0;

      if (this.datosOrigenPale.length > 0) {
        const tipoFamilia = this.datosOrigenPale[0]?.TipoArticuloFamiliaConfeccion;

        this.datosOrigenPale.forEach((pale) => {
          if (tipoFamilia !== 2) {
            this.totalEnvasesStepper += pale.ArticuloNumeroSerie.DatosOrigen[0].Partida.Cantidad;
          } else {
            pale.ArticuloNumeroSerie.DatosOrigen.forEach((datos) => {
              this.totalEnvasesStepper += datos.Partida.Cantidad;
            });
          }
        });
      }
    },

    EliminarPartida(numeroSerie, partida) {
      Log(this, this.EliminarPartida.name);
      const paleIndex = this.datosOrigenPale.findIndex((p) => p.ArticuloNumeroSerie.NumeroSerie === numeroSerie);

      delete this.valoresStepper[`${this.datosOrigenPale[paleIndex].Id}-${partida.Id}`];

      if (partida !== 0) {
        if (paleIndex !== -1) {
          const mercanciaIndex = this.datosOrigenPale[paleIndex].ArticuloNumeroSerie.DatosOrigen.findIndex((merc) => merc.Partida.Id === partida.Id);

          if (mercanciaIndex !== -1) {
            this.datosOrigenPale[paleIndex].ArticuloNumeroSerie.DatosOrigen[mercanciaIndex].Partida.Cantidad = 0;
            if (this.datosOrigenPale[paleIndex].MercanciaColaVolcado.lenght > 0) {
              const volcadoIndex = this.datosOrigenPale[paleIndex].MercanciaColaVolcado.findIndex((merc) => merc.Partidas.Id === partida.Id);
              this.datosOrigenPale[paleIndex].MercanciaColaVolcado[volcadoIndex].Partidas.Cantidad = 0;
            }
            this.datosOrigenPale[paleIndex].ArticuloNumeroSerie.DatosOrigen.splice(mercanciaIndex, 1);
            if (this.datosOrigenPale[paleIndex].ArticuloNumeroSerie.DatosOrigen.length === 0) {
              this.datosOrigenPale.splice(paleIndex, 1);
            }
          }
        }
      } else {
        this.datosOrigenPale.splice(paleIndex, 1);
      }

      this.CambiarTotalEnvases();
    },

    EliminarProductosDeImportacion(data) {
      Log(this, this.EliminarProductosDeImportacion.name);
      let ids = '';
      for (const obj of data) {
        for (const datos of obj.ArticuloNumeroSerie.DatosOrigen) {
          ids += (datos.Partida.Articulo.Id).toString();
        }
      }

      ConexionTA.callDeleteImportProducts(ids).then((result) => {
        if (result.Valor) {
          result.Tag.forEach((e) => {
            for (const obj of data) {
              const datosOrigen = obj.ArticuloNumeroSerie.DatosOrigen.filter((f) => f.Partida.Articulo.Id === Number.parseInt(e, 10));
              datosOrigen.forEach((r, i) => {
                r.Partida = this.partidasVisualizadas[i].Partida;
              });
            }
          });
        }
      })
        .catch((error) => {
          PreloaderGH(false);
          HiNotification.Toast(this.$t('common.checkYourConnection'));
          LogError(this, this.EliminarProductosDeImportacion.name, error);
        });
    },

    //* *********************** */ CONEXIONES //*************************************** */

    /**
     * @public
     * @returns {Promise<void>}
     */
    async Conections_GetOriginPallet() {
      Log(this, this.Conections_GetOriginPallet.name);
      PreloaderGH(true, false, this.$t('common.loading'));
      try {
        const resultado = await callExecuteSPERP('APPTRAZABILIDAD_NumeroSerieOrigenXArticuloElaborado', [
          { NombreParametro: 'IdArticuloNumeroSerie', Valor: this.paleEnCurso.Id_NumeroSerie },
          { NombreParametro: 'IdPuntoPalet', Valor: this.puntoDePaletizadoSeleccionado.Id },
        ], 'Trazabilidad.VolcadosPorArticuloNumeroSerieJSON');
        if (resultado.statusText === 'OK' || resultado.status === 200) {
          if (resultado.data.length > 0 && resultado.data[0].TipoArticuloFamiliaConfeccion === 2) {
            // solucion a articulosNumeroSerie diferentes con partidas iguales
            const volcados = resultado.data;

            volcados.forEach((v) => {
              v.ArticuloNumeroSerie.DatosOrigen.forEach((d) => {
                d.Partida.Cantidad = d.CantidadEnvases;
              });
            });
          }

          this.datosOrigenPale = resultado.data;
          PreloaderGH(false);
          this.CambiarTotalEnvases();
        }
      } catch (error) {
        PreloaderGH(false);
        LogError(this, this.Conections_GetOriginPallet.name, error);
      }
      PreloaderGH(false);
    },

    /**
     * @public
     * @returns {Promise<boolean>}
     */
    async ActualizarTrazabilidadCajas() {
      Log(this, this.ActualizarTrazabilidadCajas.name);
      // PreloaderGH(true, true);

      if (this.datosOrigenPale.lenght === 0 || this.datosOrigenPale === null) {
        // PreloaderGH(false);
        HiNotification.Toast(this.$t('production.assignOriginData.info.noBatchToastText'));
        return false;
      }

      const tipoFamilia = this.datosOrigenPale[0].TipoArticuloFamiliaConfeccion; // 0 - NO APLICA, 1 - NACIONAL, 2 - IMPORTACION

      if (tipoFamilia === 2) {
        this.datosOrigenPale.forEach((pale) => {
          let cantidadEnvases = 0;
          pale.ArticuloNumeroSerie.DatosOrigen.forEach((datos) => {
            cantidadEnvases += datos.Partida.Cantidad;
          });
          pale.ArticuloNumeroSerie.CantidadEnvases = cantidadEnvases;
        });
      } else {
        this.datosOrigenPale.forEach((pale) => {
          pale.ArticuloNumeroSerie.CantidadEnvases = pale.ArticuloNumeroSerie.DatosOrigen[0].Partida.Cantidad;
        });
      }
      if (this.articulosAsignados !== this.totalEnvasesStepper) {
        // PreloaderGH(false);
        HiNotification.Toast(this.$t('production.assignOriginData.info.differentPackageQuantityToastText'));
        return false;
      }

      if (this.articulosAsignados !== Number.parseInt(this.totalEnvases, 10)) {
        // PreloaderGH(false);
        HiNotification.Toast(this.$t('production.assignOriginData.info.differentElaboratedArticleQuantityToastText'));
        return false;
      }
      // PreloaderGH(false);
      PreloaderGH(true, true, this.$t('production.assignOriginData.update.preloaderText'));
      const self = this;
      const resultado = await ConexionTA.callUpdateOriginDataOfAssignedBoxXSerialNumber(this.datosOrigenPale, this.paleEnCurso.Id_NumeroSerie).then((result) => {
        PreloaderGH(false);
        if (result.Valor) {
          HiNotification.Toast(self.$t('production.assignOriginData.update.successToastText'));
          return true;
        }
        HiNotification.Toast(self.$t('production.assignOriginData.update.errorToastText'));
        return false;
      })
        .catch((error) => {
          PreloaderGH(false);
          HiNotification.Toast(this.$t('common.checkYourConnection'));
          LogError(this, this.ActualizarTrazabilidadCajas.name, error);
          return false;
        });
      return resultado;
    },
    ActualizarDatosOrigenPale() {
      Log(this, this.ActualizarDatosOrigenPale.name);
      PreloaderGH(true, true);
      const partidas = {};
      let palesFiltrados = [];

      this.ultimosPalesVolcados.forEach((pale) => {
        pale.MercanciaColaVolcado.forEach((mercancia) => {
          const indice = `${pale.Id}-${mercancia.Partidas.Id}`;

          if (Object.hasOwn(this.valoresVolcadosStepper, indice)) {
            mercancia.Partidas.Cantidad = Number.parseInt(this.valoresVolcadosStepper[indice], 10);
            partidas[indice] = mercancia.Partidas;
          }
        });
      });

      palesFiltrados = this.ultimosPalesVolcados.filter((pale) => pale.MercanciaColaVolcado.some((m) => {
        const indice = `${pale.Id}-${m.Partidas.Id}`;
        return Object.hasOwn(this.valoresVolcadosStepper, indice);
      }));

      const tempResult = this.datosOrigenPale;

      palesFiltrados.forEach((p) => {
        p.MercanciaColaVolcado.forEach((m) => {
          if (Object.hasOwn(partidas, `${p.Id}-${m.Partidas.Id}`)) {
            const partida = partidas[`${p.Id}-${m.Partidas.Id}`];
            if (tempResult !== null && tempResult.length > 0) {
              const id = p?.ArticuloNumeroSerie?.DatosOrigen?.[0]?.Id;
              this.IntroducirMercanciaColaVolcadoEnDatosOrigen(p, partida, id);
            } else {
              this.IntroducirMercanciaColaVolcadoEnDatosOrigen(p, partida, 0);
            }
          }
        });
        tempResult.push(p);
      });

      this.datosOrigenPale = tempResult;

      this.CambiarTotalEnvases();
      PreloaderGH(false);
    },
    IntroducirMercanciaColaVolcadoEnDatosOrigen(pale, partida, id) {
      if (pale.ArticuloNumeroSerie.DatosOrigen.lenght === 0) {
        pale.ArticuloNumeroSerie.DatosOrigen = [{
          Id: id + 1,
          Partida: partida,
        }];
      } else {
        pale.ArticuloNumeroSerie.DatosOrigen.push({
          Id: id + 1,
          Partida: partida,
        });
      }
    },

    ConfirmButtonClickLastDump() {
      Log(this, this.ConfirmButtonClickLastDump.name);
      this.ActualizarDatosOrigenPale();
      this.popupPalesVolcados = false;
    },
    CancelButtonClickLastDump() {
      Log(this, this.CancelButtonClickLastDump.name);
      this.popupPalesVolcados = false;
      this.valoresVolcadosStepper = {};
    },

    /**
     * Abre el popup de los palés volcados.
     * @public
     * @returns {void}
     */
    AbrirPalesVolcados() {
      Log(this, this.AbrirPalesVolcados.name);
      this.popupPalesVolcados = true;
      this.valoresVolcadosStepper = {};
      this.$refs.PCUltimosPalesVolcados.Conections_GetOverturnedPpallet(this.productoPaleEnCurso.Id);
    },

    async NumeroSerieReadingEvent(code) {
      Log(this, this.NumeroSerieReadingEvent.name);
      let paleLeido = null;

      const preloaderText = this.$t('codeScanner.info.validatingSerialNumber');
      const cancellationText = this.$t('codeScanner.info.validationCanceled');
      PreloaderGH(true, true, preloaderText, cancellationText);

      try {
        const result = await callExecuteSPERP('APPTRAZABILIDAD_ExistenciasXPaleParaJSON', [
          { NombreParametro: 'numeroSerie', Valor: code },
          { NombreParametro: 'idArticuloConfeccionado', Valor: this.productoPaleEnCurso.Id },
        ], 'Trazabilidad.VolcadosPorArticuloNumeroSerieJSON');
        if (result.statusText === 'OK' || result.status === 200) {
          PreloaderGH(false);
          paleLeido = result.data;

          if (paleLeido.length > 0) {
            const temp = this.datosOrigenPale;

            this.datosOrigenPale = null;
            const resIndex = temp.findIndex((i) => i.ArticuloNumeroSerie.NumeroSerie === paleLeido[0].ArticuloNumeroSerie.NumeroSerie);
            if (resIndex !== -1) {
              this.datosOrigenPale = temp;
              HiNotification.Toast(this.$t('production.assignOriginData.scanValidation.palletAlreadyExistsInTheList', {
                serialNumber: paleLeido[0].ArticuloNumeroSerie.NumeroSerie,
              }));
              return;
            }

            temp.push(paleLeido[0]);
            this.datosOrigenPale = temp;
          } else {
            HiNotification.Toast(this.$t('production.assignOriginData.scanValidation.palletNotFound', {
              code,
            }));
          }

          this.$refs.componentUCcodeScanner.ClosePopupReadCode();
        }
      } catch (error) {
        PreloaderGH(false);
        LogError(this, this.NumeroSerieReadingEvent.name, error);
      }
    },

    /**
     * Abre el escáner de lectura de códigos.
     * @public
     * @returns {void}
     */
    OpenCodeSearch() {
      Log(this, this.OpenCodeSearch.name);
      this.$refs.componentUCcodeScanner.Open();
    },
  },
};
</script>

<style lang="scss">
.main-pcAsignacionDatosOrigen {
  background-color: #fff;
  height: calc(100% - var(--f7-navbar-height) - 45px);

  .content-data-card-outline {
    border: none;
    background: var(--his-light-blue);
  }

  .content-card-outline__content--data {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .content-title {
      width: 80%;

      &__div {
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;

        &-title {
          color: var(--his-steel-blue);
          font-weight: 600;
          font-size: 18px;
        }

        &-subtitle {
          color: var(--his-darkgray);
          font-size: 14px;
        }

        &-text {
          color: var(--his-darkgray);
          font-size: 14px;
        }
      }
    }

    .content-after {
      span {
        display: flex;
        color: var(--his-steel-blue);
        font-weight: 600;
        font-size: 16px;
        margin-right: 12px;

        img {
          margin-left: 5px;
        }
      }
    }
  }

  .content-data-list {
    overflow-y: scroll;
    border: 1px solid var(--his-silver);

    &__data {
      display: grid;
      grid-template-columns: 3fr 1fr 1fr;
      grid-column-gap: 5px;
      justify-content: space-between;

      &--title {
        justify-content: center;
        display: flex;
        flex-direction: column;

        span {
          -webkit-box-orient: vertical;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
        }

        .title {
          color: var(--his-steel-blue);
          font-size: 18px;
          font-weight: 600;
        }

        .subtitle {
          color: var(--his-darkgray);
          font-size: 14px;
          font-weight: 500;
        }
      }

      &--kilos {
        display: flex;
        flex-direction: column;
        align-items: center;

        .content-kilos-number {
          font-size: 32px;
        }
      }

      &--delete {
        display: flex;
        justify-content: center;
      }
    }
  }
}

.content-last-dump-popup {
  &__buttons {
    .content-buttons-origin-data-asignation {
      background: #fff;
      display: flex;
      justify-content: space-between;
      flex-direction: row;

      .button-reject {
        color: var(--his-darkgray);
      }

      .button-confirm {
        color: var(--his-orange);
        font-size: 16px;
      }
    }
  }
}
</style>
